import { Component, OnInit } from '@angular/core';

import { ScanButtonComponent } from "@softline/application";

@Component({
    selector: 'soft-artikel-input',
    imports: [ScanButtonComponent],
    templateUrl: './artikel-input.component.html',
    styleUrls: ['./artikel-input.component.css']
})
export class ArtikelInputComponent implements OnInit {


  constructor() { }
  ngOnInit(): void {
  }

}
